import React from 'react';

export const useService = (promise, triggers = []) => {
  const [data, setData] = React.useState();
  const [error, setError] = React.useState();
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    setData(undefined);
    setError(undefined);
    setLoading(true);
    promise()
      .then(response => setData(response), e => setError(e))
      .finally(() => setLoading(false));
  }, triggers);
  return {
    data,
    error,
    loading,
  };
};
